export default "__VITE_ASSET__2a406681__"